module.exports = __webpack_public_path__ + "static/img/al.4eb491e7.svg";